exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".photo-viewer[data-v-3fe095b3]{width:100%;height:100%;background-color:#000}div img[data-v-3fe095b3]{display:block;max-height:100%;max-width:100%;width:auto;height:auto;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}", ""]);

// exports
